const StoreModules = {
  ADMIN: 'admin',
  CUSTOMER: 'customer',
  APPOINTMENT: 'appointment'
};

export default StoreModules;
